export default __webpack_public_path__ + "static/media/amc-logo.54e7a4bd.png";